/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { AppCSS, ChkInputBox, Spacer, TxtInput } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import * as React from "react";
import { Container } from "../../../../globalstyled";

import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import plusIcon from "../../../../images/PlusIcon.png";
import editIcon from "../../../../images/EditIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import ContractorDrawer from "../SideDrawer/index";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";
import {
  ArrowIcon,
  FormTitleTypography,
  StandardIcon,
} from "../itemCreation.styled";
import deleteIcon from "../../../../images/DeleteIcon.png";
import visibleIcon from "../../../../images/visible.png";
import TableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";
import { uploadImage } from "../../../../redux/api/common";
import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import {
  CONTRACTORS_TABLE_HEADER_LIST,
  PHOTOS_ROW_HEADERS,
  TRADE_TABLE_VIEW_ROW_HEADER_LIST,
  FILE_TABLE_HEADER_LIST,
  TRADES_TABLE_HEADER_LIST,
} from "../../../../contants/dashboardHeader";

import UpArrowIcon from "../../../../images/UploadIcon.png";
import DownArrowIcon from "../../../../images/DownloadIcon.png";

import {
  ContractorFile,
  Contractors,
  ProductSystem,
} from "../../../../redux/types/creation";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logEvent, ITEM_CREATION_EVENTS } from "../../../../utils/amplitude";
import { SFileUpload } from "../../../../components/input/input.styled";
import { FileOpen } from "@mui/icons-material";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import Pagination from "../ItemCreationComponent/Pagination";
import MaterialItemsProductSystemTableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import {
  CONTRACTOR_DRAWER_DETAILS,
  SELECT_CONTRACTOR_FILETYPE,
} from "../../../../contants/itemsCreation";
import EmptyTable from "../../../../components/table/EmptyTable";
import ProductSystemParentIdsTable from "../ItemCreationComponent/ProductSystemParentIdsTable";
import {
  useArchiveContractor,
  useCreateContractor,
  useUpdateContractor,
} from "../../../../apolloClient/hooks/itemCreation/createHooks";
import { useCreateUploadUrl } from "../../../../apolloClient/hooks/general/createHook";
import {
  ContractorFileInput,
  ContractorTradeInput,
  CreateContractorInput,
  CreateUploadFileInput,
  UpdateContractorInput,
  ContractFieldType,
  ContractorFieldInput,
} from "../../../../types/graphQlQuery.interface.d";
import { ContractorFields } from "../../../../redux/types/creation";
import FileUploadTable from "../ItemCreationComponent/FileUploadTable";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";
import PDFSignatureModal from "../../../../components/PDFSignatureModal";

// Mapping from our frontend variable names to backend ContractFieldType enum
const FIELD_TYPE_MAPPING: { [key: string]: ContractFieldType } = {
  customerName: ContractFieldType.CUSTOMER_NAME,
  propertyAddress: ContractFieldType.SHIPPING_ADDRESS,
  date: ContractFieldType.DATE,
  signature: ContractFieldType.SIGNATURE,
  initial: ContractFieldType.INITIAL,
  amount: ContractFieldType.AMOUNT,
  lineItems: ContractFieldType.LINE_ITEMS,
  phone: ContractFieldType.PHONE,
  email: ContractFieldType.EMAIL
};

// Helper function to convert ContractorFields (from backend) to ContractorFieldInput (for input)
const convertContractorFieldsToInput = (fields: ContractorFields[]): ContractorFieldInput[] => {
  return fields.map(field => ({
    fieldType: field.fieldType as ContractFieldType,
    page: field.page,
    x: field.x,
    y: field.y,
    width: field.width,
    height: field.height
  }));
};

interface ContractorsTableProps {
  contractorsData: Contractors[];
  refetchContractors?: Function;
  productsIds?: ProductSystem[];
  permissions?: boolean;
}

export const ContractorsTable: React.FC<ContractorsTableProps> = ({
  contractorsData,
  refetchContractors,
  productsIds,
  permissions,
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(8);
  const [keyword, setKeyword] = React.useState("");

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openPhotoFormDrawer, setOpenPhotoFormDrawer] = React.useState(false);

  const [openTradeFormDrawer, setOpenTradeFormDrawer] = React.useState(false);
  const [editTradeId, setEditTradeId] = React.useState<number | null>(null);
  const [photoFormDataArr, setPhotoFormDataArr] = React.useState<
    ContractorFileInput[]
  >([]);

  const [tradesFormDataArr, setTradesFormDataArr] = React.useState<
    ContractorTradeInput[]
  >([]);

  const [openRowDetailsDrawer, setOpenRowDetailsDrawer] =
    React.useState<boolean>(false);

  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<Contractors | null>(null);

  const [contractorFormField, setContractorFormField] =
    useState<CreateContractorInput>({
      name: "",
      email: "",
      website: "",
      description: "",
      files: [],
      trades: [],
      parentIds: [],
    });

  const [contractorPhotoFormField, setContractorPhotoFormField] =
    useState<ContractorFileInput>({
      name: "",
      description: "",
      fileType: null,
      url: "",
    });

  const [contractorEditPhotoDetails, setContractorEditPhotoDetails] =
    useState<ContractorFileInput>({
      name: "",
      description: "",
      fileType: null,
      url: "",
    });


  const [contractorTradesFormField, setContractorTradesFormField] =
    useState<ContractorTradeInput>({
      name: "",
      description: "",
      yearsOfDoing: null,
    });

  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadUrl, setUploadUrl] = useState("");
  const [isEditPhotoDetails, setIsEditPhotoDetails] = useState<boolean>(false);
  const [isEditTradeDetails, setIsEditTradeDetails] = useState<boolean>(false);
  const [parentIds, setParentIds] = useState([]);

  const [fileUrl, setFileUrl] = useState<string>("");
  const [selectedFileName, setSelectedFileName] = useState<string>(""); // Track selected file name

  const truncateText = (text: string, length: number) => {
    if (!text) return ""; // Return empty string if no text
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const { createContractor } = useCreateContractor();
  const { updateContractor } = useUpdateContractor();
  const { archiveContractor } = useArchiveContractor();

  const [openArchieveDialog, setOpenArchieveDialog] = useState(false);
  const [selectedContractor, setSelectedContractor] =
    useState<Contractors | null>(null);

  // PDF Signature Modal states
  const [openPDFSignatureModal, setOpenPDFSignatureModal] = useState(false);
  const [currentPDFUrl, setCurrentPDFUrl] = useState("");
  const [currentPDFFileName, setCurrentPDFFileName] = useState("");
  const [currentPDFFile, setCurrentPDFFile] = useState<File | null>(null); // Store file locally before upload

  // States for editing existing PDF files
  const [editingExistingPDF, setEditingExistingPDF] = useState(false);
  const [currentEditingFileIndex, setCurrentEditingFileIndex] = useState<number | null>(null);


  const handleArchive = (row: Contractors) => {
    setSelectedContractor(row);
    setOpenArchieveDialog(true);
  };

  const confirmArchieve = async () => {
    if (selectedContractor) {
      const success = await archiveContractor(selectedContractor.id);
      if (success) {
        toast(`${selectedContractor.name} Archived!`, { type: "error" });
        logEvent(ITEM_CREATION_EVENTS.CONTRACTOR_ARCHIVED, { contractor_id: selectedContractor.id, contractor_name: selectedContractor.name, timestamp: new Date().toISOString() });
        refetchContractors();
      } else {
        toast(`Failed to Archive ${selectedContractor.name}`);
      }
      setOpenArchieveDialog(false);
      setSelectedContractor(null);
    }
  };

  const cancelArchieve = () => {
    setOpenArchieveDialog(false);
    setSelectedContractor(null);
  };

  // PDF Signature Modal handlers
  const handlePDFSignatureModalClose = () => {
    setOpenPDFSignatureModal(false);
    setCurrentPDFUrl("");
    setCurrentPDFFileName("");
    setCurrentPDFFile(null);
    setSelectedFileName(""); // Clear selected file name
    // Close the file upload drawer as well
    setContractorPhotoFormField({
      name: "",
      description: "",
      url: "",
      fileType: null,
    });
    setOpenPhotoFormDrawer(false);
    setUploadUrl("");
  };

  // Function to handle editing existing PDF files with field placements
  const handleEditExistingPDF = (fileIndex: number) => {
    const file = photoFormDataArr[fileIndex];
    if (!file || !file.url) {
      toast('Unable to locate the PDF file. Please try again.', { type: 'error' });
      return;
    }

    // Check if the file type is LABOR_CONTRACT
    if (file.fileType !== 'LABOR_CONTRACT') {
      toast('Field placement is only available for Labor Contract files', { type: 'error' });
      return;
    }

    // Set up the PDF signature modal for editing existing file
    setCurrentPDFUrl(file.url);
    setCurrentPDFFileName(file.name);
    setCurrentPDFFile(null); // No file upload needed for existing files
    setEditingExistingPDF(true);
    setCurrentEditingFileIndex(fileIndex);

    setOpenPDFSignatureModal(true);
  };

  // Helper function to convert field type back to variable name
  const getVariableNameFromFieldType = (fieldType: ContractFieldType): string | undefined => {
    const reverseMapping = Object.entries(FIELD_TYPE_MAPPING).find(([_, value]) => value === fieldType);
    return reverseMapping ? reverseMapping[0] : undefined;
  };

  // Helper function to convert ContractorFieldInput to FieldMarker format for PDFSignatureModal
  const convertFieldsToMarkers = (fields: ContractorFieldInput[]): any[] => {
    return fields.map((field, index) => {

      // Treat both SIGNATURE and INITIAL as 'signature' type for consistent styling
      const isSignatureType = field.fieldType === ContractFieldType.SIGNATURE || field.fieldType === ContractFieldType.INITIAL;

      // For INITIAL fields, set variableName to 'initial' so they can be distinguished from regular signatures
      let variableName: string | undefined;
      if (field.fieldType === ContractFieldType.INITIAL) {
        variableName = 'initial';
      } else if (!isSignatureType) {
        variableName = getVariableNameFromFieldType(field.fieldType);
      } else {
        variableName = undefined; // Regular signature
      }

      return {
        id: `${field.fieldType}-${field.page}-${field.x}-${field.y}-${index}`,
        type: isSignatureType ? 'signature' : 'variable',
        x: 0.5, // Temporary - will be recalculated when PDF loads
        y: 0.5, // Temporary - will be recalculated when PDF loads
        pageNumber: field.page,
        absoluteX: field.x,
        absoluteY: field.y,
        variableName: variableName,
      };
    });
  };

  // Function to handle updating existing PDF file fields
  const handleUpdateExistingPDFFields = async (markers: any[], modifiedPdfFile?: File): Promise<void> => {
    if (currentEditingFileIndex === null) return;

    try {
      // Transform markers to the new GraphQL schema format
      const transformedFields = markers
        .filter(m => m.type === 'signature' || m.type === 'variable')
        .map(marker => {
          let fieldType: ContractFieldType;

          if (marker.type === 'signature') {
            // Check if this is an initial field (has variableName 'initial')
            if (marker.variableName === 'initial') {
              fieldType = ContractFieldType.INITIAL;
            } else {
              fieldType = ContractFieldType.SIGNATURE;
            }
          } else if (marker.type === 'variable') {
            fieldType = FIELD_TYPE_MAPPING[marker.variableName] || ContractFieldType.SIGNATURE;
          } else {
            fieldType = ContractFieldType.SIGNATURE; // fallback
          }

          return {
            fieldType: fieldType,
            page: marker.pageNumber,
            x: parseFloat(marker.absoluteX.toString()),
            y: parseFloat(marker.absoluteY.toString())
            // width and height are optional - removed to let backend handle defaults
          };
        });

      // Update the specific file in photoFormDataArr

      // Wrap state update in a Promise to ensure it completes
      await new Promise<void>((resolve) => {
        setPhotoFormDataArr(prev => {
          const updated = [...prev];
          const fileToUpdate = updated[currentEditingFileIndex];


          if (modifiedPdfFile) {
            // If there's a modified PDF (with embedded text), we need to upload it
            // For now, we'll just update the fields - file upload would need additional handling
          }

          updated[currentEditingFileIndex] = {
            ...fileToUpdate,
            fields: transformedFields
          };


          // Use setTimeout to resolve after state update
          setTimeout(resolve, 0);
          return updated;
        });
      });


      const textFieldsCount = markers.filter(m => m.type === 'text').length;
      const processedFieldsCount = transformedFields.length;
      const message = modifiedPdfFile
        ? `PDF updated with ${processedFieldsCount} signature/variable field(s) and ${textFieldsCount} embedded text field(s)`
        : `PDF updated with ${processedFieldsCount} signature/variable field(s)`;

      toast(message, { type: 'success' });

      // Reset editing states
      setEditingExistingPDF(false);
      setCurrentEditingFileIndex(null);
      setOpenPDFSignatureModal(false);
      setCurrentPDFUrl("");
      setCurrentPDFFileName("");
      setCurrentPDFFile(null);

    } catch (error) {
      console.error('Error updating PDF fields:', error);
      toast('Unable to save PDF field placements. Please try again.', { type: 'error' });
    }
  };

  const handleSaveSignaturePlacements = async (markers: any[], modifiedPdfFile?: File) => {
    if (modifiedPdfFile) {
    }

    // Handle editing existing PDF files
    if (editingExistingPDF && currentEditingFileIndex !== null) {
      return handleUpdateExistingPDFFields(markers, modifiedPdfFile);
    }

    if (!currentPDFFile && !modifiedPdfFile) {
      toast('Please select a PDF file first', { type: 'error' });
      return;
    }

    try {
      // Create upload URL for the PDF file
      const input: CreateUploadFileInput = {
        contentType: "application/pdf",
      };

      const uploadUrlResult = await createUploadUrl(input);
      if (!uploadUrlResult) {
        toast('Unable to prepare file upload. Please try again.', { type: 'error' });
        return;
      }

      // Upload the PDF file (use modified version if available, otherwise original)
      const fileToUpload = modifiedPdfFile || currentPDFFile;
      const result = await uploadImage(uploadUrlResult.url, fileToUpload);

      if (result.success) {
        // Transform markers to the new GraphQL schema format
        // Only include signature, variable, and initial fields (exclude custom text as it's embedded in PDF)
        const transformedFields = markers
          .filter(m => m.type === 'signature' || m.type === 'variable')
          .map(marker => {
            let fieldType: ContractFieldType;

            if (marker.type === 'signature') {
              // Check if this is an initial field (has variableName 'initial')
              if (marker.variableName === 'initial') {
                fieldType = ContractFieldType.INITIAL;
              } else {
                fieldType = ContractFieldType.SIGNATURE;
              }
            } else if (marker.type === 'variable') {
              fieldType = FIELD_TYPE_MAPPING[marker.variableName] || ContractFieldType.SIGNATURE;
            } else {
              fieldType = ContractFieldType.SIGNATURE; // fallback
            }

            return {
              fieldType: fieldType,
              page: marker.pageNumber,
              x: parseFloat(marker.absoluteX.toString()),
              y: parseFloat(marker.absoluteY.toString())
              // width and height are optional - removed to let backend handle defaults
            };
          });

        const photoFormData: ContractorFileInput = {
          name: contractorPhotoFormField.name,
          description: contractorPhotoFormField.description,
          url: uploadUrlResult.fileName,
          fileType: contractorPhotoFormField.fileType,
          totalPages: undefined, // Will be calculated by backend
          fields: transformedFields
        };

        setPhotoFormDataArr((prevPhotoFormData) => [
          ...prevPhotoFormData,
          photoFormData,
        ]);

        // Log the data that would be sent to backend

        const textFieldsCount = markers.filter(m => m.type === 'text').length;
        const processedFieldsCount = transformedFields.length;
        const message = modifiedPdfFile
          ? `PDF uploaded with ${processedFieldsCount} signature/variable field(s) and ${textFieldsCount} embedded text field(s)`
          : `PDF uploaded with ${processedFieldsCount} signature/variable field(s)`;

        toast(message, { type: 'success' });

        // Reset states
        setContractorPhotoFormField({
          name: "",
          description: "",
          url: "",
          fileType: null,
        });
        setOpenPhotoFormDrawer(false);
        setOpenPDFSignatureModal(false);
        setCurrentPDFUrl("");
        setCurrentPDFFileName("");
        setCurrentPDFFile(null);
            setUploadUrl("");
      }
    } catch (error) {
      console.error('Error uploading PDF:', error);
      toast('Failed to upload PDF', { type: 'error' });
    }
  };

  const { createUploadUrl } = useCreateUploadUrl();

  const [showProductSystemParent, setShowProductSystemParent] =
    useState<boolean>(false);

  const [checkboxProductSystemStates, setCheckboxProductSystemStates] =
    useState<{
      [key: number]: boolean;
    }>({});

  const [isEditContractor, setIsEditContractor] = useState<boolean>(false); // State to track edit mode
  const [contractorEditDetails, setContractorEditDetails] =
    useState<Contractors | null>(null); // State to hold contractor details for editing
  const [removedFiles, setRemovedFiles] = useState<number[]>([]); // State to track removed files
  const [removedTrades, setRemovedTrades] = useState<number[]>([]); // State to track removed trades

  const getUplaodUrl = async () => {
    // Skip upload URL creation for LABOR_CONTRACT files - they'll upload after PDF field placement
    if (contractorPhotoFormField.fileType === "LABOR_CONTRACT") {
      return;
    }

    const input: CreateUploadFileInput = {
      contentType: "image/jpeg",
    };

    const success = await createUploadUrl(input);
    if (success) {
      setUploadUrl(success.url);
      setFileUrl(success.fileName);
      return;
    } else {
      console.error("Failed to create Upload url.");
    }
  };

  const handleOpenFileDrawer = () => {
    setOpenPhotoFormDrawer(true);
    if (isEditPhotoDetails) {
      setContractorPhotoFormField({
        name: "",
        description: "",
        url: "",
        fileType: null,
      });
      setIsEditPhotoDetails(false);
    }
  };

  const handleOpenTradesDrawer = () => {
    setOpenTradeFormDrawer(true);
    if (isEditTradeDetails) {
      setContractorTradesFormField({
        name: "",
        description: "",
        yearsOfDoing: null,
      });
      setIsEditTradeDetails(false);
    }
  };

  const handleSelectFileType = (event, selectedFileType) => {
    if (selectedFileType) {
      setContractorPhotoFormField((prevItem) => ({
        ...prevItem,
        fileType: selectedFileType.label,
      }));
    }
  };

  const handlePhotoFormData = async () => {
    const file = fileRef.current?.files[0];

    const validationRules = [
      {
        condition: !contractorPhotoFormField.name,
        message: "File name is required",
      },
      {
        condition: !contractorPhotoFormField.description,
        message: "File description is required",
      },
      {
        condition: !contractorPhotoFormField.fileType,
        message: "File fileType is required",
      },
      {
        condition: !file,
        message: "A file have not been selected",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    // Check if the file is a PDF AND if it's a LABOR_CONTRACT file type BEFORE uploading
    const isPdf = file?.type === 'application/pdf';
    const isLaborContract = contractorPhotoFormField.fileType === 'LABOR_CONTRACT';

    if (isPdf && isLaborContract) {
      // For LABOR_CONTRACT PDFs: Open editor first, upload later
      const blobUrl = URL.createObjectURL(file);
      setCurrentPDFUrl(blobUrl);
      setCurrentPDFFileName(contractorPhotoFormField.name);
      setCurrentPDFFile(file);
      setOpenPDFSignatureModal(true);
      // Don't upload yet! Will upload after user finishes editing
      return;
    } else if (isPdf && !isLaborContract) {
      // For non-LABOR_CONTRACT PDFs: Show message and upload without placement features
    }

    // For non-PDF files: Upload immediately
    try {
      const result = await uploadImage(uploadUrl, file);
      if (result.success) {
        let photoFormData: ContractorFileInput = {
          name: contractorPhotoFormField.name,
          description: contractorPhotoFormField.description,
          url: fileUrl,
          fileType: contractorPhotoFormField.fileType,
        };

        setPhotoFormDataArr((prevPhotoFormData) => [
          ...prevPhotoFormData,
          photoFormData,
        ]);

        setContractorPhotoFormField({
          name: "",
          description: "",
          url: "",
          fileType: null,
        });
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const handleTradeFormData = () => {
    const validationRules = [
      {
        condition: !contractorTradesFormField.name,
        message: "Trade name is required",
      },
      {
        condition: !contractorTradesFormField.description,
        message: "Trade description is required",
      },
      {
        condition: !contractorTradesFormField.yearsOfDoing,
        message: "Years of Doing Trade is required",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    let tradeFormData: ContractorTradeInput = {
      name: contractorTradesFormField.name,
      description: contractorTradesFormField.description,
      yearsOfDoing: contractorTradesFormField.yearsOfDoing,
    };

    setTradesFormDataArr((prevTradeFormData) => [
      ...prevTradeFormData,
      tradeFormData,
    ]);

    setContractorTradesFormField({
      name: "",
      description: "",
      yearsOfDoing: null,
    });
    setOpenTradeFormDrawer(false);
  };

  const viewRowDetails = (rowData: Contractors) => {
    setViewRowDetailsData(rowData);
    handleViewRowDetailsDrawerOpen();
  };

  const handleViewRowDetailsDrawerOpen = () => {
    setOpenRowDetailsDrawer(true);
  };

  const handleViewRowDetailsDrawerClose = () => {
    setOpenRowDetailsDrawer(false);
  };

  const handleSubmitEditPhotoFormData = async () => {
    const file = fileRef.current?.files[0];

    try {
      if (file) {
        const result = await uploadImage(uploadUrl, file);
        if (result.success) {
          let photoFormData: ContractorFileInput = {
            name: contractorPhotoFormField.name,
            description: contractorPhotoFormField.description,
            url: fileUrl,
            fileType: contractorPhotoFormField.fileType,
          };

          const updatedPhotoFormDataArr = photoFormDataArr.filter(
            (photoData) => photoData.url !== contractorEditPhotoDetails.url
          );

          updatedPhotoFormDataArr.push(photoFormData);

          setPhotoFormDataArr(updatedPhotoFormDataArr);

          setContractorPhotoFormField({
            name: "",
            description: "",
            url: "",
            fileType: null,
          });
          setOpenPhotoFormDrawer(false);
          setUploadUrl("");
          setIsEditPhotoDetails(false);
        }
      } else {
        let photoFormData: ContractorFileInput = {
          name: contractorPhotoFormField.name,
          description: contractorPhotoFormField.description,
          url: contractorEditPhotoDetails.url,
          fileType: contractorPhotoFormField.fileType,
        };

        const updatedPhotoFormDataArr = photoFormDataArr.filter(
          (photoData) => photoData.url !== contractorEditPhotoDetails.url
        );

        updatedPhotoFormDataArr.push(photoFormData);

        setPhotoFormDataArr(updatedPhotoFormDataArr);

        setContractorPhotoFormField({
          name: "",
          description: "",
          url: "",
          fileType: null,
        });
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
        setIsEditPhotoDetails(false);
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const handleCancelFileForm = () => {
    setOpenPhotoFormDrawer(false);
    setUploadUrl("");
    setIsEditPhotoDetails(false);
    setSelectedFileName(""); // Clear selected file name
    setContractorPhotoFormField({
      name: "",
      description: "",
      url: "",
      fileType: null,
    });
  };

  const handleCancelTradeForm = () => {
    setContractorTradesFormField({
      name: "",
      description: "",
      yearsOfDoing: null,
    });
    setOpenTradeFormDrawer(false);
    setIsEditTradeDetails(false);
    setEditTradeId(null);
  };

  const handleSubmitEditTradeFormData = () => {
    let tradeFormData: ContractorTradeInput = {
      name: contractorTradesFormField.name,
      description: contractorTradesFormField.description,
      yearsOfDoing: contractorTradesFormField.yearsOfDoing,
    };

    const updatedTradeFormDataArr = tradesFormDataArr.filter(
      (_, index) => index !== editTradeId
    );

    updatedTradeFormDataArr.push(tradeFormData);

    setTradesFormDataArr(updatedTradeFormDataArr);

    setContractorTradesFormField({
      name: "",
      description: "",
      yearsOfDoing: null,
    });
    setOpenTradeFormDrawer(false);
    setIsEditTradeDetails(false);
    setEditTradeId(null);
  };

  const handleEditPhotoFormData = (rowData: ContractorFileInput) => {
    const { id, name, description, url, fileType } = rowData;

    
    setContractorEditPhotoDetails({
      id, 
      name,
      description: description || "", 
      url,
      fileType,
    });

    
    setContractorPhotoFormField({
      id,
      name,
      description: description || "", 
      url,
      fileType: fileType || null, 
    });

    setOpenPhotoFormDrawer(true);
    setIsEditPhotoDetails(true);
  };

  const handleEditTradeFormData = (
    rowData: ContractorTradeInput,
    id: number
  ) => {
    const { name, description, yearsOfDoing } = rowData;
    setContractorTradesFormField({
      name,
      description,
      yearsOfDoing,
    });
    setOpenTradeFormDrawer(true);
    setIsEditTradeDetails(true);
    setEditTradeId(id);
  };

  const handleChange = (value: string, name: string) => {
    setContractorFormField((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handlePhotoChange = (value: string, name: string) => {
    setContractorPhotoFormField((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleTradeChange = (value: string, name: string) => {
    setContractorTradesFormField((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const filterContractors = () => {
    if (keyword.length > 0 && Array.isArray(contractorsData)) {
      return contractorsData.filter((item) => {
        const contractorsName = `${item.name}`;
        const contractorsWebsite = `${item.website}`;
        return (
          contractorsName.toLowerCase().includes(keyword.toLowerCase()) ||
          contractorsWebsite.toLowerCase().includes(keyword.toLowerCase())
        );
      });
    }
    return contractorsData;
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterContractors().length / rowsPerPage) - 1
      )
    );
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setIsEditContractor(false);
    setPhotoFormDataArr([]);
    setTradesFormDataArr([]);
    setCheckboxProductSystemStates({});
    setRemovedFiles([]);
    setRemovedTrades([]);
    setContractorFormField({
      name: "",
      email: "",
      website: "",
      description: "",
      files: [],
      trades: [],
      parentIds: [],
    });
    setShowProductSystemParent(false)
    setParentIds([]);
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !contractorFormField.name,
        message: "Name is required",
      },
      {
        condition: !contractorFormField.website,
        message: "Website is required",
      },
      {
        condition: !contractorFormField.description,
        message: "Description is required",
      },
      {
        condition: photoFormDataArr.length === 0,
        message: "File is yet to be added",
      },
      {
        condition: tradesFormDataArr.length === 0,
        message: "Trade is yet to be added",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    // Transform files to include fields (signature and variable fields)
    const transformedFiles = photoFormDataArr.map((file: any) => ({
      name: file.name,
      description: file.description,
      url: file.url,
      fileType: file.fileType,
      totalPages: file.totalPages,
      fields: file.fields || undefined // Use the new fields structure
    }));

    const input: CreateContractorInput = {
      name: contractorFormField.name,
      email: contractorFormField.email || undefined,
      website: contractorFormField.website,
      description: contractorFormField.description,
      files: transformedFiles,
      trades: tradesFormDataArr,
      parentIds: parentIds,
    };

    const success = await createContractor(input);

    if (success) {
      toast("Contractor created successfully.", {
        type: "success",
        className: "toast-message",
        position: "top-center",
      });
      logEvent(ITEM_CREATION_EVENTS.CONTRACTOR_CREATED, { contractor_name: contractorFormField.name, timestamp: new Date().toISOString() });
      refetchContractors();
      handleDrawerClose();
      setContractorFormField({
        name: "",
        email: "",
        website: "",
        description: "",
        files: [],
        trades: [],
        parentIds: [],
      });
      setPhotoFormDataArr([]);
      setTradesFormDataArr([]);
      // Reset checkbox states (clear selected checkboxes)
      setCheckboxProductSystemStates({});
      return;
    } else {
      console.error("Failed to create contractor.");
    }
  };

  const handleCheckboxChange = (value: boolean, id: number) => {
    setCheckboxProductSystemStates((prevCheckboxStates) => {
      const updatedCheckboxStates = {
        ...prevCheckboxStates,
        [id]: value,
      };
  
      // Update parentIds based on the updated checkbox states
      const updatedParentIds = Object.keys(updatedCheckboxStates)
        .filter((key) => updatedCheckboxStates[Number(key)])
        .map(Number);
  
      setParentIds(updatedParentIds); // Sync parentIds with checkbox states
      return updatedCheckboxStates;
    });
  };

  const handleEditContractor = (contractor: Contractors) => {
    setContractorEditDetails(contractor);

    const mappedFiles = (contractor.files || []).map((file) => ({
      id: file.id,
      name: file.name,
      description: file.description || "", // Ensure description is not null
      fileType: file.fileType,
      url: file.url,
      totalPages: file.totalPages,
      fields: file.fields ? convertContractorFieldsToInput(file.fields) : [], // Convert backend fields to input format
    }));

    const mappedTrades = (contractor.trades || []).map((trade) => ({
      id: trade.id,
      name: trade.name,
      description: trade.description || "",
      yearsOfDoing: trade.yearsOfDoing,
    }));

    setContractorFormField({
      name: contractor.name,
      email: contractor.email || "",
      website: contractor.website,
      description: contractor.description,
      files: mappedFiles,
      trades: mappedTrades,
      parentIds: contractor.parents?.map((parent) => parent.id) || [],
    });

    setPhotoFormDataArr(mappedFiles);
    setTradesFormDataArr(mappedTrades);

    const productSystemStates = (contractor.parents || []).reduce(
      (acc, parent) => ({ ...acc, [parent.id]: true }),
      {}
    );
    setCheckboxProductSystemStates(productSystemStates);

    setIsEditContractor(true);
    handleDrawerOpen();
  };

  const handleRemoveFile = (fileId: number) => {
    setRemovedFiles((prev) => [...prev, fileId]);
    setPhotoFormDataArr((prev) => prev.filter((file) => file.id !== fileId));
  };

  const handleRemoveTrade = (tradeId: number) => {
    setRemovedTrades((prev) => [...prev, tradeId]);
    setTradesFormDataArr((prev) =>
      prev.filter((trade) => trade.id !== tradeId)
    );
  };

  const onTapSubmitEditForm = async () => {

    const validationRules = [
      {
        condition: !contractorFormField.name,
        message: "Name is required",
      },
      {
        condition: !contractorFormField.website,
        message: "Website is required",
      },
      {
        condition: !contractorFormField.description,
        message: "Description is required",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    // Debug: Log current photoFormDataArr state

    // Separate files into different categories
    const newFiles = photoFormDataArr.filter(file => !file.id);
    const existingFilesWithFieldChanges = photoFormDataArr.filter(file =>
      file.id &&
      file.fileType === 'LABOR_CONTRACT' && // Only LABOR_CONTRACT files support field placements
      file.fields && file.fields.length > 0
    );


    // Transform only truly new files for addedFiles
    const transformedAddedFiles = newFiles.map((file: any) => {

      // Only include field data for LABOR_CONTRACT files
      const fieldsData = file.fileType === 'LABOR_CONTRACT' ? file.fields : undefined;

      return {
        name: file.name,
        description: file.description,
        url: file.url,
        fileType: file.fileType,
        totalPages: file.totalPages,
        fields: fieldsData
      };
    });



    // Since the backend doesn't support updatedFiles, we'll need to use the addedFiles approach
    // but include existing files with modifications in addedFiles and their IDs in removedFiles
    const allAddedFiles = [...transformedAddedFiles];
    const allRemovedFileIds = [...removedFiles];

    // Re-enabled: Backend has fixed foreign key constraint issue
    // For existing files with field changes, add them to both addedFiles and removedFiles
    // This implements the remove + add pattern for field updates
    existingFilesWithFieldChanges.forEach(file => {

      // Add to addedFiles (new version with updated fields)
      allAddedFiles.push({
        name: file.name,
        description: file.description,
        url: file.url,
        fileType: file.fileType,
        totalPages: file.totalPages,
        fields: file.fields
      });

      // Add to removedFiles (remove old version)
      allRemovedFileIds.push(file.id);
    });

    // Log successful field updates
    if (existingFilesWithFieldChanges.length > 0) {
    }


    const input: UpdateContractorInput = {
      id: contractorEditDetails?.id!,
      name: contractorFormField.name,
      email: contractorFormField.email || undefined,
      website: contractorFormField.website,
      description: contractorFormField.description,
      addedFiles: allAddedFiles,
      removedFiles: allRemovedFileIds,
      updatedTrades: tradesFormDataArr.filter((trade) => !trade.id),
      removedTrades,
      parentIds,
    };


    let success: any;
    try {
      success = await updateContractor(input);
    } catch (error: any) {
      console.error('Update contractor failed:', error);
      toast('Failed to update contractor. Please try again.', { type: 'error' });
      return;
    }

    if (success) {
      toast("Contractor updated successfully.", {
        type: "success",
        className: "toast-message",
        position: "top-center",
      });
      logEvent(ITEM_CREATION_EVENTS.CONTRACTOR_UPDATED, { contractor_id: contractorEditDetails?.id, contractor_name: contractorFormField.name, timestamp: new Date().toISOString() });
      refetchContractors();
      handleDrawerClose();
      setIsEditContractor(false);
      setContractorFormField({
        name: "",
        email: "",
        website: "",
        description: "",
        files: [],
        trades: [],
        parentIds: [],
      });
      setPhotoFormDataArr([]);
      setTradesFormDataArr([]);
      setRemovedFiles([]);
      setRemovedTrades([]);
      setCheckboxProductSystemStates({});
      return;
    } else {
      console.error("Failed to update contractor.");
    }
  };

  const createContractorsForm = () => {
    return (
      <ContractorDrawer open={openDrawer} onClose={handleDrawerClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle={
              isEditContractor ? "Edit contractor" : "Create new contractor"
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <ColDiv
                style={{
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Name</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter name"
                  onChange={handleChange}
                  required={true}
                  value={contractorFormField.name}
                  name="name"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Email</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter Contractor Email"
                  onChange={handleChange}
                  required={false}
                  value={contractorFormField.email}
                  name="email"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                  type="email"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Website</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter contractor's website"
                  onChange={handleChange}
                  required={true}
                  value={contractorFormField.website}
                  name="website"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Description</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter public description"
                  onChange={handleChange}
                  required={true}
                  value={contractorFormField.description}
                  name="description"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Files</FormTitleTypography>
                  <StandardIcon src={plusIcon} onClick={handleOpenFileDrawer} />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingY: "10px",
                  }}
                >
                  {photoFormDataArr.length > 0 && (
                    <LeadsTableHeaderCard
                      headers={FILE_TABLE_HEADER_LIST}
                      fontSize={"14px"}
                    />
                  )}

                  {photoFormDataArr.map((contractor, contractorIndex) => (
                    <TableWithoutHeader
                      key={`Contractor file ${contractorIndex}`}
                      containerWidth="100%"
                      bodyContent={[
                        {
                          text: `${contractorIndex + 1}`,
                          width: "10%",
                          fontSize: "12px",
                        },
                        {
                          text: `${contractor.name}`,
                          width: "15%",
                          fontSize: "12px",
                        },
                        {
                          text: `${contractor.description}`,
                          width: "30%",
                          fontSize: "12px",
                        },
                        {
                          text: `${contractor.fileType}`,
                          width: "20%",
                        },
                        {
                          text: "",
                          width: "25%",
                          justifyContent: "end",
                          isAction: true,
                          actionComponent: (
                            <div style={{ display: "flex" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <a
                                  href={`${contractor.url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  download={false}
                                >
                                  <StandardIcon src={visibleIcon} />
                                </a>
                              </Box>
                              <Box
                                onClick={() => {
                                  handleEditPhotoFormData(contractor);
                                }}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <StandardIcon src={editIcon} />
                              </Box>
                              {/* {contractor.fileType === "LABOR_CONTRACT" && (
                                <Box
                                  onClick={() => handleEditExistingPDF(contractorIndex)}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    paddingRight: "20px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#e3f2fd",
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                    marginRight: "8px",
                                    "&:hover": {
                                      backgroundColor: "#bbdefb",
                                    },
                                  }}
                                  title="Edit PDF Field Placements"
                                >
                                  <Typography sx={{ fontSize: "10px", color: "#1976d2", fontWeight: 600 }}>
                                    PDF Fields
                                  </Typography>
                                </Box>
                              )} */}
                              <Box
                                onClick={() => handleRemoveFile(contractor.id!)}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <StandardIcon src={deleteIcon} />
                              </Box>
                            </div>
                          ),
                        },
                      ]}
                    />
                  ))}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Trades</FormTitleTypography>
                  <StandardIcon
                    src={plusIcon}
                    onClick={handleOpenTradesDrawer}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingY: "10px",
                  }}
                >
                  {tradesFormDataArr.length > 0 && (
                    <LeadsTableHeaderCard
                      headers={TRADES_TABLE_HEADER_LIST}
                      fontSize={"14px"}
                    />
                  )}
                  {tradesFormDataArr.map((trade, tradeIndex) => (
                    <TableWithoutHeader
                      key={`trade ${tradeIndex}`}
                      containerWidth="100%"
                      bodyContent={[
                        {
                          text: `${tradeIndex + 1}`,
                          width: "10%",
                          fontSize: "12px",
                        },
                        {
                          text: `${trade.name}`,
                          width: "15%",
                          fontSize: "12px",
                        },
                        {
                          text: `${trade.description}`,
                          width: "30%",
                          fontSize: "12px",
                        },
                        {
                          text: `${trade.yearsOfDoing}`,
                          width: "30%",
                          fontSize: "12px",
                        },
                        {
                          text: "",
                          width: "15%",
                          justifyContent: "end",
                          isAction: true,
                          actionComponent: (
                            <div style={{ display: "flex" }}>
                              <Box
                                onClick={() => {
                                  handleEditTradeFormData(trade, tradeIndex);
                                }}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <StandardIcon src={editIcon} />
                              </Box>
                              <Box
                                onClick={() => handleRemoveTrade(trade.id!)}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <StandardIcon src={deleteIcon} />
                              </Box>
                            </div>
                          ),
                        },
                      ]}
                    />
                  ))}
                </Box>

                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              cursor: "pointer",
              justifyContent: "start",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Lbl
              title="Associated product systems"
              size={16}
              width={80}
              bold={600}
            />
          </Box>

          <Box
            sx={{
              width: "96%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
              justifyContent: "center",
              background: "inherit",
              borderRadius: "10px",
              border: "1px solid rgba(173, 173, 173, 1)",
              height: "fit-content",
              minHeight: "50px",
              paddingY: "10px",
            }}
            onClick={() => setShowProductSystemParent(!showProductSystemParent)}
          >
            <RowDiv
              style={{
                width: "100%",
                paddingLeft: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "60%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Lbl
                  title="Select associated product systems"
                  size={16}
                  mobileFontSize={16}
                  isFullWidth={true}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "40%",
                  alignItems: "center",
                  justifyContent: "end",
                  paddingRight: "20px",
                }}
              >
                {showProductSystemParent ? (
                  <ArrowIcon src={UpArrowIcon} />
                ) : (
                  <ArrowIcon src={DownArrowIcon} />
                )}
              </Box>
            </RowDiv>

            {showProductSystemParent && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  justifyContent: "center",
                  alignItems: "start",
                  width: "100%",
                  paddingX: "20px",
                }}
              >
                {productsIds.map((item) => (
                  <Box
                    key={`checkProductsSystemParent misc ${item.id}`}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      cursor: "pointer",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <ChkInputBox
                      onChange={(value: boolean) =>
                        handleCheckboxChange(value, item.id)
                      }
                      placeholder=""
                      width={50}
                      marginTop={0}
                      marginBottom={0}
                      height={20}
                      background="inherit"
                      checked={checkboxProductSystemStates[item.id] || false}
                    />
                    <Typography>{item.name}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleDrawerClose}
          submitText={isEditContractor ? "Update" : "Create"}
          onCreate={isEditContractor ? onTapSubmitEditForm : onTapSubmitForm}
        />
      </ContractorDrawer>
    );
  };

  const createPhotoForm = () => {
    return (
      <ContractorDrawer
        open={openPhotoFormDrawer}
        onClose={() => {
          setOpenPhotoFormDrawer(false);
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => {
              setOpenPhotoFormDrawer(false);
            }}
            labelTitle={
              isEditPhotoDetails ? "Edit Photo Details" : "Add contractor photo"
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <ColDiv
                style={{
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Photo name</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter name"
                  onChange={handlePhotoChange}
                  required={true}
                  value={contractorPhotoFormField.name}
                  name="name"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Photo description</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter description"
                  onChange={handlePhotoChange}
                  required={true}
                  value={contractorPhotoFormField.description}
                  name="description"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <FormTitleTypography
                  style={{
                    display: "felx",
                    width: "60%",
                    justifyContent: "start",
                    textAlign: "start",
                  }}
                >
                  Select File Type
                </FormTitleTypography>

                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    background: "inherit",
                    borderRadius: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      sx={{ width: "100%" }}
                      options={SELECT_CONTRACTOR_FILETYPE.map((fileType) => ({
                        id: fileType.label,
                        label: fileType.label,
                      }))}
                      value={
                        contractorPhotoFormField.fileType
                          ? {
                              id: contractorPhotoFormField.fileType,
                              label: contractorPhotoFormField.fileType,
                            }
                          : null
                      }
                      onChange={handleSelectFileType}
                      renderInput={(params) => (
                        <TextField {...params} label="Select File Type" />
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Upload File</FormTitleTypography>
                </Box>

                <Box
                  sx={{
                    width: "96%",
                    marginX: "2%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",

                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "60%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Lbl
                      title={
                        uploadUrl !== "" ? "Photo uploaded" : "Upload file"
                      }
                      size={16}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "40%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SFileUpload
                      style={{
                        border: "none",
                        marginLeft: 10,
                        height: "35px",
                        width: "100px",
                        backgroundColor: "white",
                      }}
                      onClick={() => {
                        if (fileRef.current) {
                          fileRef.current.click();
                        }
                      }}
                    >
                      <input
                        type="file"
                        id="file"
                        ref={fileRef}
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            setSelectedFileName(file.name);
                          }
                          if (uploadUrl === "") {
                            getUplaodUrl();
                          }
                        }}
                        accept={"image/png, image/jpeg, image/jpg,.pdf"}
                        style={{
                          display: "none",
                        }}
                      />
                      <FileOpen
                        titleAccess="Select File"
                        color="warning"
                        style={{
                          width: 32,
                          height: 32,
                          color: AppCSS.GLAS_GREEN,
                        }}
                      />
                    </SFileUpload>
                  </Box>
                </Box>
                {selectedFileName && (
                  <Box
                    sx={{
                      marginTop: "8px",
                      padding: "8px",
                      backgroundColor: contractorPhotoFormField.fileType === "LABOR_CONTRACT" ? "#fff3cd" : "#f5f5f5",
                      border: contractorPhotoFormField.fileType === "LABOR_CONTRACT" ? "1px solid #ffeaa7" : "1px solid #ddd",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Selected file:
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {selectedFileName}
                    </Typography>
                    {contractorPhotoFormField.fileType === "LABOR_CONTRACT" && (
                      <Typography variant="caption" sx={{ color: "#856404", fontStyle: "italic" }}>
                        (PDF will be uploaded after field placement)
                      </Typography>
                    )}
                  </Box>
                )}
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleCancelFileForm}
          onCreate={
            isEditPhotoDetails
              ? handleSubmitEditPhotoFormData
              : handlePhotoFormData
          }
          submitText={"Save"}
        />
      </ContractorDrawer>
    );
  };

  const createTradeForm = () => {
    return (
      <ContractorDrawer
        open={openTradeFormDrawer}
        onClose={() => {
          setOpenTradeFormDrawer(false);
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => {
              setOpenTradeFormDrawer(false);
            }}
            labelTitle={
              isEditTradeDetails ? "Edit Trade Details" : "Add contractor trade"
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <ColDiv
              style={{
                gap: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  cursor: "pointer",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "30px",
                }}
              >
                {" "}
                <FormTitleTypography>Trade Name</FormTitleTypography>
              </Box>
              <TxtInput
                placeholder="Enter name"
                onChange={handleTradeChange}
                required={true}
                value={contractorTradesFormField.name}
                name="name"
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  cursor: "pointer",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "30px",
                }}
              >
                {" "}
                <FormTitleTypography>Trade Description</FormTitleTypography>
              </Box>
              <TxtInput
                placeholder="Enter description"
                onChange={handleTradeChange}
                required={true}
                value={contractorTradesFormField.description}
                name="description"
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  cursor: "pointer",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "30px",
                }}
              >
                {" "}
                <FormTitleTypography>Years Doing Trade</FormTitleTypography>
              </Box>
              <TxtInput
                placeholder="Enter number of years"
                onChange={handleTradeChange}
                required={true}
                value={contractorTradesFormField.yearsOfDoing}
                name="yearsOfDoing"
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={50}
                type="number"
              />

              <Spacer size={1} direction="col" />
            </ColDiv>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleCancelTradeForm}
          onCreate={
            isEditTradeDetails
              ? handleSubmitEditTradeFormData
              : handleTradeFormData
          }
          submitText={"Save"}
        />
      </ContractorDrawer>
    );
  };

  const TradesTable = ({ value, key }: { value: any[]; key: String }) => (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
      }}
    >
      <LeadsTableHeaderCard
        headers={TRADE_TABLE_VIEW_ROW_HEADER_LIST}
        fontSize={"14px"}
      />
      {value.map((trade: any, index: number) => (
        <MaterialItemsProductSystemTableWithoutHeader
          key={`${key} trade_${index}`}
          bodyContent={[
            {
              text: `${trade.id}`,
              width: "5%",
              fontSize: "12px",
            },
            {
              text: `${trade.name}`,
              width: "25%",
              fontSize: "12px",
            },
            {
              text: ` ${trade.description}`,
              width: "40%",
              fontSize: "12px",
            },
            {
              text: `${trade.yearsOfDoing}`,
              width: "30%",
              fontSize: "12px",
            },
          ]}
        />
      ))}
    </Box>
  );

  const showContractorsRowDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openRowDetailsDrawer}
        handleDrawerClose={handleViewRowDetailsDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Contractor Details"
        rowArrayTableComponent={(value: ContractorFile[], key?: string) => (
          <FileUploadTable value={value} key={key} />
        )}
        rowArrayTableComponentTwo={(value: ContractorFile[], key?: string) => (
          <TradesTable value={value} key={key} />
        )}
        detailsOfRowToBeDisplay={CONTRACTOR_DRAWER_DETAILS}
      />
    );
  };

  const ContractorsTable = () => {
    const paginatedData = filterContractors().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterContractors().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search contractors"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          {permissions && (
            <Box
              component="button"
              onClick={() => handleDrawerOpen()}
              sx={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#4b87ed",
                color: "white",
                border: "none",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#3a6fd8",
                },
              }}
            >
              + Create new contractor
            </Box>
          )}
        </Box>

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "8%", minWidth: "50px" }}>ID</Box>
            <Box sx={{ width: "20%", minWidth: "80px" }}>Name</Box>
            <Box sx={{ width: "22%", minWidth: "100px" }}>Website</Box>
            <Box sx={{ width: "25%", minWidth: "100px" }}>Description</Box>
            <Box sx={{ width: "25%", minWidth: "150px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body */}
          {filterContractors().length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                No Contractor available
              </Typography>
            </Box>
          ) : (
            paginatedData.map((contractor, contractorIndex) => (
              <Box
                key={`contractor-${contractorIndex}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  padding: { xs: "14px 16px", md: "14px 20px" },
                  borderBottom: "1px solid #f0f0f0",
                  gap: { xs: 1, md: 0 },
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child": {
                    borderBottom: "none",
                  },
                }}
              >
                {/* ID */}
                <Box sx={{ width: { xs: "100%", md: "8%" }, minWidth: { md: "50px" }, paddingRight: { md: "16px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    ID
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                    {contractor.id}
                  </Typography>
                </Box>

                {/* Name */}
                <Box sx={{ width: { xs: "100%", md: "20%" }, minWidth: { md: "80px" }, paddingRight: { md: "16px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Name
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {contractor.name}
                  </Typography>
                </Box>

                {/* Website */}
                <Box sx={{ width: { xs: "100%", md: "22%" }, minWidth: { md: "100px" }, maxWidth: { md: "22%" }, paddingRight: { md: "16px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >  Website
                  </Typography>
                  <Typography 
                    sx={{ 
                      fontSize: 14, 
                      color: "#374151",
                      wordBreak: "break-all",
                      lineHeight: 1.4
                    }}
                  >
                    {contractor.website}
                  </Typography>
                </Box>

                {/* Description */}
                <Box sx={{ width: { xs: "100%", md: "25%" }, minWidth: { md: "100px" }, maxWidth: { md: "25%" }, paddingRight: { md: "16px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Description
                  </Typography>
                  <Typography 
                    sx={{ 
                      fontSize: 14, 
                      color: "#374151",
                      wordBreak: "break-word",
                      lineHeight: 1.4
                    }}
                  >
                    {truncateText(contractor.description, 30)}
                  </Typography>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "25%" },
                    minWidth: { md: "150px" },
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1,
                    flexWrap: "wrap",
                    marginTop: { xs: 1, md: 0 },
                  }}
                >
                  <Box
                    component="button"
                    onClick={() => viewRowDetails(contractor)}
                    sx={{
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#e5e7eb",
                      color: "#374151",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  >
                    View
                  </Box>
                  {permissions && (
                    <>
                      <Box
                        component="button"
                        onClick={() => handleEditContractor(contractor)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#e5e7eb",
                          color: "#374151",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#d1d5db",
                          },
                        }}
                      >
                        Edit
                      </Box>
                      <Box
                        component="button"
                        onClick={() => handleArchive(contractor)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#fee2e2",
                          color: "#dc2626",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#fecaca",
                          },
                        }}
                      >
                        Archive
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            ))
          )}

          {/* Pagination */}
          {filterContractors().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const contractorsContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(contractorsData) && ContractorsTable()}
        {createContractorsForm()}
        {showContractorsRowDetails()}
        {createPhotoForm()}
        {createTradeForm()}
      </Box>
    );
  };

  return (
    <>
      {contractorsContainer()}
      <ConfirmationDialog
        open={openArchieveDialog}
        title="Confirm Archive"
        message={`Are you sure you want to Archive "${selectedContractor?.name}"?`}
        onConfirm={confirmArchieve}
        onCancel={cancelArchieve}
      />
      <PDFSignatureModal
        open={openPDFSignatureModal}
        onClose={handlePDFSignatureModalClose}
        pdfUrl={currentPDFUrl}
        fileName={currentPDFFileName}
        onSaveSignaturePlacements={handleSaveSignaturePlacements}
        initialFieldMarkers={
          editingExistingPDF && currentEditingFileIndex !== null
            ? convertFieldsToMarkers(photoFormDataArr[currentEditingFileIndex]?.fields || [])
            : []
        }
      />
    </>
  );
};
